import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { JobPriority } from '../job'
import { ElderChipsModule } from '@elderbyte/ngx-starter'
import { MatChip, MatChipSet } from '@angular/material/chips'

@Component({
  selector: 'app-job-priority-indicator',
  templateUrl: './job-priority-indicator.component.html',
  styleUrls: ['./job-priority-indicator.component.scss'],
  imports: [MatChipSet, MatChip, ElderChipsModule],
})
export class JobPriorityIndicatorComponent {
  public name: string
  public levelColor: any

  constructor() {}

  @Input()
  public set priority(priority: JobPriority) {
    this.name = this.priorityToName(priority)
    this.levelColor = this.priorityToLevel(priority)
  }

  private priorityToLevel(priority: JobPriority): any {
    if (priority === null) {
      return undefined
    }
    switch (priority) {
      case JobPriority.none:
        return undefined
      case JobPriority.background:
        return 'background'
      case JobPriority.low:
        return 'low'
      case JobPriority.medium:
        return 'medium'
      case JobPriority.high:
        return 'high'
      default:
        return undefined
    }
  }

  private priorityToName(priority: JobPriority): string {
    if (priority === null) {
      return 'none'
    }

    switch (priority) {
      case JobPriority.none:
        return 'none'
      case JobPriority.background:
        return 'background'
      case JobPriority.low:
        return 'low'
      case JobPriority.medium:
        return 'medium'
      case JobPriority.high:
        return 'high'
      default:
        return 'P-' + priority
    }
  }
}
